module.exports = __webpack_public_path__ + "img/1.768593e8.jpg";